import { Dialog } from "@mui/material";
import { useScale } from "common/utils";
import { ParentCloseBtn, FadeTransition } from "common/elements";
import i18n from "features/parent/i18n";
import { FeedbackHistoryItem } from "features/parent/types";
import { FeedbackChatMessage } from "./FeedbackChatMessage";

interface FeedbackDetailModalProps {
  item: FeedbackHistoryItem;
  childIcon?: string;
  onClose: () => void;
}

export const FeedbackDetailModal = ({ item, childIcon, onClose }: FeedbackDetailModalProps) => {
  const { scale } = useScale();

  return (
    <Dialog
      fullScreen
      open={true}
      maxWidth={false}
      sx={{ zIndex: 99999 }}
      TransitionComponent={FadeTransition}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-center w-full h-full bg-textcolor-black/50">
        <div style={{ transform: `scale(${scale})` }}>
          <div className="flex-col-el w-[600px] border-solid border-gray2-30 border-[16px] rounded-[16px] bg-gray2-30">
            <div className="flex-col-view justify-start w-full h-full relative p-6 rounded-[8px] bg-white">
              <ParentCloseBtn close={onClose} />
              {/* タイトル */}
              <div className="flex-row-el items-center gap-2 mb-4 pb-3 border-b border-outline">
                <span className="material-symbols-outlined !text-[54px] text-red-100">forum</span>
                <h2 className="text-[33px] text-textcolor-black">
                  {i18n.t("MSG_PARENT_PAGE_FEEDBACK_DETAIL")}
                </h2>
              </div>

              {/* チャット形式のメッセージ表示 */}
              <FeedbackChatMessage item={item} childIcon={childIcon} />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
